<template>
  <table class="c-order-totals u-margin-bottom-large">
    <tr>
      <th
        class="t-heading-9 u-text-align-left"
        scope="row"
      >
        Subtotal
      </th>
      <td class="c-order-totals__cell">
        {{ subtotal }}
      </td>
    </tr>
    <tr class="c-order-totals__tax">
      <th
        class="c-order-totals__indent t-heading-9 u-text-align-left"
        scope="row"
      >
        Taxes
      </th>
      <td class="c-order-totals__cell">
        {{ tax }}
      </td>
    </tr>
    <tr class="c-order-totals__shipping">
      <th
        class="c-order-totals__indent t-heading-9 u-text-align-left"
        scope="row"
      >
        Shipping
      </th>
      <td class="c-order-totals__cell">
        {{ shipping }}
      </td>
    </tr>
    <tr
      v-if="discounts"
      class="c-order-totals__discount"
    >
      <th
        class="c-order-totals__discount-line c-order-totals__indent u-text-align-left t-heading-9"
        scope="row"
      >
        Discounts
      </th>
      <td class="c-order-totals__cell c-order-totals__discount-line">
        -{{ discounts }}
      </td>
    </tr>
    <tr class="c-order-totals__total u-margin-bottom-x-small">
      <th
        class="u-text-align-left t-heading-6"
        scope="row"
      >
        Total
      </th>
      <td class="c-order-totals__cell c-order-totals__bottom-line">
        {{ price }}
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'OrderTotals',
  props: {
    subtotal: {
      type: String,
      default: '',
    },
    tax: {
      type: String,
      default: '',
    },
    shipping: {
      type: String,
      default: '',
    },
    discounts: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.c-order-totals {
  width: 100%;
  margin-left: auto;
  border-collapse: collapse;

  @include respond-min('tab-port') {
    max-width: rem(350px);
  }

  &__indent {
    padding-left: rem(8px);
  }
  
  &__cell {
    text-align: right;
  }

  &__discount-line {
    padding-bottom: rem(10px);
  }
  
  &__total {
    @include themify($themes) {
      border-top: $border themed('foreground', 'select');
    }
  }

  &__bottom-line {
    padding-top: rem(10px);
  }
}
</style>